import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import { TQuestion } from '@/libs/apis/queries/use-get-survey-question-query'
import { TQuestionWithAnswer } from '@/libs/logics/parse-question-with-answer'

export type TSubmissionInitialState = {
  submissionId: null | string
  surveyType: null | string
  surveyName: null | string
  totalQuestions: number
  questions: TQuestion[]
  answers: TQuestionWithAnswer[]
}

const initialState: TSubmissionInitialState = {
  submissionId: null,
  surveyType: null,
  surveyName: null,
  totalQuestions: 0,
  questions: [],
  answers: [],
}

const submissionSlice = createSlice({
  name: 'submission',
  initialState,
  extraReducers(builder) {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    resetSubmission: (state) => {
      state.answers = []
      state.questions = []
      state.totalQuestions = 0
    },
    setAnswers: (state, action) => {
      state.answers = action.payload
    },
    removeQuestion: (state) => {
      const questions = [...state.questions]

      questions.pop()

      state.questions = questions
    },
    appendQuestion: (state, action) => {
      const questions = [...state.questions]

      questions.push(action.payload)

      state.questions = questions
    },
    setQuestion: (state, action) => {
      state.questions = action.payload
    },
    setTotalQuestions: (state, action) => {
      state.totalQuestions = action.payload
    },
    setSurveyType: (state, action) => {
      state.surveyType = action.payload
    },
    clearSurveyType: (state) => {
      state.surveyType = null
    },
    setSurveyName: (state, action) => {
      state.surveyName = action.payload
    },
    clearSurveyName: (state) => {
      state.surveyName = null
    },
    setSubmissionId: (state, action) => {
      state.submissionId = action.payload
    },
    clearSubmissionId: (state) => {
      state.submissionId = null
    },
    clearSubmission: (state) => {
      state.submissionId = null
      state.surveyName = null
      state.surveyType = null
    },
  },
})

export const {
  clearSubmission,
  setSubmissionId,
  clearSubmissionId,
  setSurveyType,
  clearSurveyType,
  setSurveyName,
  clearSurveyName,
  appendQuestion,
  removeQuestion,
  setTotalQuestions,
  setQuestion,
  setAnswers,
  resetSubmission,
} = submissionSlice.actions

export default submissionSlice.reducer
